import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgUnitedKingdomFlagIcon = (props) => /* @__PURE__ */ _jsxs("svg", {
	id: "flag-icon-css-gb",
	xmlns: "http://www.w3.org/2000/svg",
	xmlnsXlink: "http://www.w3.org/1999/xlink",
	x: "0px",
	y: "0px",
	viewBox: "0 0 512 512",
	style: { enableBackground: "new 0 0 512 512" },
	xmlSpace: "preserve",
	...props,
	children: [/* @__PURE__ */ _jsx("style", {
		type: "text/css",
		children: "\n	.uk-flag-st0{fill:#000066;}\n	.uk-flag-st1{fill:#FFFFFF;}\n	.uk-flag-st2{fill:#CC0000;}\n"
	}), /* @__PURE__ */ _jsx("g", { children: /* @__PURE__ */ _jsx("g", {
		transform: "translate(-256) scale(1.024)",
		children: /* @__PURE__ */ _jsxs("g", { children: [
			/* @__PURE__ */ _jsx("rect", {
				x: 244,
				y: -6,
				className: "uk-flag-st0",
				width: 512,
				height: 512
			}),
			/* @__PURE__ */ _jsxs("g", { children: [
				/* @__PURE__ */ _jsx("polygon", {
					className: "uk-flag-st1",
					points: "250,69.1 250,180.9 388.2,250 500,194.1  "
				}),
				/* @__PURE__ */ _jsx("polygon", {
					className: "uk-flag-st1",
					points: "750,180.9 750,69.1 500,194.1 611.8,250  "
				}),
				/* @__PURE__ */ _jsx("polygon", {
					className: "uk-flag-st1",
					points: "250,430.9 500,305.9 388.2,250 250,319.1  "
				}),
				/* @__PURE__ */ _jsx("polygon", {
					className: "uk-flag-st1",
					points: "750,430.9 750,319.1 611.8,250 500,305.9  "
				})
			] }),
			/* @__PURE__ */ _jsx("polygon", {
				className: "uk-flag-st1",
				points: "750,166.7 583.3,166.7 583.3,0 416.7,0 416.7,166.7 250,166.7 250,333.3 416.7,333.3 416.7,500 583.3,500 583.3,333.3 750,333.3  "
			}),
			/* @__PURE__ */ _jsxs("g", { children: [
				/* @__PURE__ */ _jsx("polygon", {
					className: "uk-flag-st2",
					points: "250,412.3 407.9,333.3 333.3,333.3 250,375  "
				}),
				/* @__PURE__ */ _jsx("polygon", {
					className: "uk-flag-st2",
					points: "250,125 250,162.3 258.8,166.7 333.3,166.7  "
				}),
				/* @__PURE__ */ _jsx("polygon", {
					className: "uk-flag-st2",
					points: "592.1,166.7 666.7,166.7 750,125 750,87.7  "
				}),
				/* @__PURE__ */ _jsx("polygon", {
					className: "uk-flag-st2",
					points: "741.2,333.3 666.7,333.3 750,375 750,337.7  "
				}),
				/* @__PURE__ */ _jsx("polygon", {
					className: "uk-flag-st2",
					points: "550,200 550,0 450,0 450,200 250,200 250,300 450,300 450,500 550,500 550,300 750,300 750,200 "
				})
			] })
		] })
	}) })]
});
export default SvgUnitedKingdomFlagIcon;
